export class MeetingAttendeeSelectors {
  static peopleOptions = 'peopleOptions';
}